import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';

import SubPageWrapper from '../../common/SubPageWrapper';
import PromoCodes from '../settings/promoCodes/PromoCodes';
import LoyaltyForm from '../settings/loyalty/container/LoyaltyForm';
import RoleAwareLink from '../../common/RoleAwareLink';
import { brandRewardsEnabled } from '../../auth/selectors';
import { canUserViewPromos } from '../../common/helpers/users';
import { t } from '../../../modules/infra/i18n';

const mapStateToProps = (state, ownProps) => ({
  page: ownProps.params.page,
  brandCanViewPromos: canUserViewPromos(state.auth.permissions),
  brandLoyaltyEnabled: brandRewardsEnabled(state),
});

export default compose(
  connect(mapStateToProps, null),
  withHandlers({
    getPages: () => () => ({
      promo: {
        component: (<PromoCodes />),
        title: t('common:navigation.promo_codes'),
      },
      'loyalty-program': {
        component: (<LoyaltyForm />),
        title: t('common:navigation.loyalty_program'),
      },
    }),
  }),
  withProps(props => ({
    pages: props.getPages(),
    menuItems: [{
      label: t('common:navigation.promo_codes'),
      to: '/discounts/promo',
      displayIf: props.brandCanViewPromos,
      component: RoleAwareLink,
    }, {
      label: t('common:navigation.loyalty_program'),
      to: '/discounts/loyalty-program',
      displayIf: props.brandLoyaltyEnabled,
      component: RoleAwareLink,
    }],
  })),
)(SubPageWrapper);
